import Immutable from 'immutable';

import type Url from 'sharedreact/data/Url';

const Content: {
  id?: string,
  fileUrl: Url | null,
  fileType: string | null,
  available: boolean
} = {
  id: undefined, // TODO FileInfoStructuralDesign should have an id that is set by the server
  fileUrl: null,
  fileType: null,
  available: false
};

class FileInfoStructuralDesign extends Immutable.Record(Content) {
}

export default FileInfoStructuralDesign;
